import { Fragment } from 'react'
import { Button, Card } from 'react-bootstrap'
import { PRIZE_STATES } from '../../constants/prizes'
import axios from 'axios'
import config from '../../config'
import Cookies from 'js-cookie'
import { useDispatch } from 'react-redux'

const PrizeReportPage = ({ state, selectedRound, getStates }) => {
  const dispatch = useDispatch()
  const handleClickDownloadPrizeReport = async () => {
    dispatch({ type: 'loading_show' })
    const result = await axios.get(
      `${config.apiAdminGateway}/api/v2/prizes/report?name=prizes-info&roundDate=${selectedRound?.value}`,
      {
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      },
    )

    if (result.data.status.code === 0) {
      const { url } = result.data.data
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `prize-report-${selectedRound?.value}.pdf`)
      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)
    } else {
      await getStates()
    }
    dispatch({ type: 'loading_hide' })
  }

  const handleClickDownloadTransferReport = async () => {
    dispatch({ type: 'loading_show' })
    const result = await axios.get(
      `${config.apiAdminGateway}/api/v2/prizes/report/transfer?roundDate=${selectedRound?.value}`,
      {
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      },
    )

    if (result.data.status.code === 0) {
      const { url } = result.data.data
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `transfer-report-${selectedRound?.value}.pdf`)
      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)
    } else {
      await getStates()
    }

    dispatch({ type: 'loading_hide' })
  }

  const handleClickLineNotify = async () => {
    dispatch({ type: 'loading_show' })
    await axios.post(
      `${config.apiAdminGateway}/api/v2/prizes/notify`,
      {
        roundDate: selectedRound?.value,
      },
      {
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      },
    )

    await getStates()
    dispatch({ type: 'loading_hide' })
  }

  return (
    <Fragment>
      <Card.Body
        className="d-flex justify-content-center flex-column m-auto"
        style={{
          minHeight: '400px',
        }}
      >
        <Button className="mb-4" variant="info" onClick={handleClickDownloadPrizeReport}>
          Download ไฟล์ข้อมูลรางวัล
        </Button>
        <Button variant="info" onClick={handleClickDownloadTransferReport}>
          Download ไฟล์โอนเงิน
        </Button>
      </Card.Body>
      {state === PRIZE_STATES.REPORT_GENERATED && (
        <Card.Footer className="d-flex justify-content-center" onClick={handleClickLineNotify}>
          <Button variant="success">ส่ง LINE</Button>
        </Card.Footer>
      )}
    </Fragment>
  )
}

export default PrizeReportPage
